import { createSelector } from 'reselect';
import { State } from 'store/types';

const selectPropertyAnalysis = (state: State) => state.propertyAnalysis;

export const selectPropertyAnalysisItems = createSelector(
  selectPropertyAnalysis,
  (state) => state.items,
);

export const selectPropertyAnalysisUpdatedProperty = createSelector(
  selectPropertyAnalysis,
  (state) => state.updatedProperty,
);

export const selectPropertyAnalysisSummary = createSelector(
  selectPropertyAnalysis,
  (state) => state.summary,
);

export const selectPropertyAnalysisPagination = createSelector(
  selectPropertyAnalysis,
  (state) => state.pagination,
);

export const selectPropertyAnalysisFilter = createSelector(
  selectPropertyAnalysis,
  (state) => state.filter,
);

export const selectPropertyAnalysisFilterOptions = createSelector(
  selectPropertyAnalysis,
  (state) => state.filterOptions,
);

export const selectPropertyAnalysisFilterOptionsLoadStatus = createSelector(
  selectPropertyAnalysis,
  (state) => state.filterOptionsLoadStatus,
);

export const selectPropertyAnalysisIsLoading = createSelector(
  selectPropertyAnalysis,
  (state) => state.isLoading,
);

export const selectPropertyAnalysisIsLoaded = createSelector(
  selectPropertyAnalysis,
  (state) => state.isLoaded,
);

export const selectPropertyAnalysisError = createSelector(
  selectPropertyAnalysis,
  (state) => state.error,
);

export const selectPropertyAnalysisExportLoadStatus = createSelector(
  selectPropertyAnalysis,
  (state) => state.exportLoadStatus,
);

export const selectPropertyAnalysisExportError = createSelector(
  selectPropertyAnalysis,
  (state) => state.exportError,
);

export const selectPropertyAnalysisDecisionUpdatePropertyId = createSelector(
  selectPropertyAnalysis,
  (state) => state.decisionUpdatePropertyId,
);

export const selectPropertyAnalysisDecisionUpdateError = createSelector(
  selectPropertyAnalysis,
  (state) => state.decisionUpdateError,
);

export const selectPropertyAnalysisDecisionUpdateErrorPropertyId =
  createSelector(
    selectPropertyAnalysis,
    (state) => state.decisionUpdateErrorPropertyId,
  );

export const selectPropertyAnalysisDerivedFieldUpdatePropertyId =
  createSelector(
    selectPropertyAnalysis,
    (state) => state.derivedFieldUpdatePropertyId,
  );

export const selectPropertyAnalysisDerivedFieldUpdateField = createSelector(
  selectPropertyAnalysis,
  (state) => state.derivedFieldUpdateField,
);

export const selectPropertyAnalysisDerivedFieldUpdateError = createSelector(
  selectPropertyAnalysis,
  (state) => state.derivedFieldUpdateError,
);
